<template>
  <div v-if="$store.state.auth.loggedIn && request.user">
      <div v-if="request.accepted == null">
        <div>
          Please accept or reject the user {{ request.user.first_name }} {{ request.user.last_name }} ({{ request.user.email }}) to the organization {{ request.organization.name }}
        </div>

        <b-button @click="sendAcceptRejectRequest(true)">Accept</b-button>
        <b-button @click="sendAcceptRejectRequest(false)">Reject</b-button>
        <div v-if="message">
          {{ message }}
        </div>
      </div>
      <div v-else>
          This request has already been {{ request.accepted ? 'accepted' : 'rejected' }}.
      </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      request: {},
      message: null,
    };
  },
  props: {
    requestId: String,
  },
  async created() {
    if (!this.$store.state.auth.loggedIn) {
      this.$router.push({ name: 'signin', query: { redirectUrl: `/partners/joinRequest/${this.requestId}` } });
    }

    const response = await axios.get(`${process.env.VUE_APP_API_USERS_ROOT}/organizations/requests/${this.requestId}`);
    this.request = response.data;
  },
  methods: {
    async sendAcceptRejectRequest(accept) {
      const url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/requests/${this.requestId}/${accept}`;
      const response = await axios.patch(url);

      if (response.status === 200) {
        this.message = `You have successfully ${accept ? 'accepted' : 'rejected'} this request.`;
        window.setTimeout(() => { this.$router.push('/'); }, 5000);
      } else {
        this.message = JSON.parse(response.data).message;
      }
    },
  },
};
</script>

<style>

</style>
